import LanguageMultiSelect from "./LanguageMultiSelect";

// Patient languages on the New/Edit Patient forms, side by side: the languages
// they understand (names, same multi-select as the doctor form) and the one to
// communicate in (a "hi-IN" style code - questionnaires open in it unless the
// patient picks their own in the app).
export const PATIENT_LANGUAGES = [
  ["en-US", "English", "English"], ["hi-IN", "Hindi", "हिन्दी"], ["bn-IN", "Bengali", "বাংলা"], ["mr-IN", "Marathi", "मराठी"],
  ["te-IN", "Telugu", "తెలుగు"], ["ta-IN", "Tamil", "தமிழ்"], ["gu-IN", "Gujarati", "ગુજરાતી"], ["kn-IN", "Kannada", "ಕನ್ನಡ"],
  ["ml-IN", "Malayalam", "മലയാളം"], ["or-IN", "Odia", "ଓଡ଼ିଆ"], ["pa-IN", "Punjabi", "ਪੰਜਾਬੀ"], ["ur-IN", "Urdu", "اردو"],
  ["as-IN", "Assamese", "অসমীয়া"], ["sa-IN", "Sanskrit", "संस्कृतम्"],
];
export const languageName = (code) => (PATIENT_LANGUAGES.find(([c]) => c === code) || [null, code])[1];

export default function PatientLanguageFields({ language, languagesKnown, onChange }) {
  const known = Array.isArray(languagesKnown) ? languagesKnown : [];
  const knownCodes = PATIENT_LANGUAGES.filter(([, name]) => known.includes(name));
  const choices = knownCodes.length ? knownCodes : PATIENT_LANGUAGES;

  const setKnown = (names) => {
    const codes = PATIENT_LANGUAGES.filter(([, name]) => names.includes(name)).map(([c]) => c);
    // keep the communication language among the known ones when possible
    onChange({ languages_known: names, language: codes.length && !codes.includes(language) ? codes[0] : language });
  };

  return (
    <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
      <div>
        <label className="block text-sm font-semibold text-secondary-700 mb-2 ml-1">Languages the patient understands</label>
        <LanguageMultiSelect value={known} onChange={setKnown} placeholder="Select or type languages (e.g. Hindi, Marathi)..." />
      </div>
      <div>
        <label htmlFor="patient_language" className="block text-sm font-semibold text-secondary-700 mb-2 ml-1">Patient communication language</label>
        <select id="patient_language" value={language || "en-US"}
          onChange={(e) => {
            const name = languageName(e.target.value);
            onChange({ language: e.target.value, languages_known: known.includes(name) ? known : [...known, name] });
          }}
          className="w-full px-4 py-3 border border-secondary-200 rounded-xl bg-secondary-50 text-secondary-900 focus:outline-none focus:ring-2 focus:ring-primary-400/50">
          {choices.map(([code, name, native]) => <option key={code} value={code}>{name}{native !== name ? ` - ${native}` : ""}</option>)}
        </select>
        <p className="text-xs text-secondary-500 mt-1 ml-1">Questionnaires open in this language when a translation exists.</p>
      </div>
    </div>
  );
}
